import { render } from "./ReportTable.vue?vue&type=template&id=a870d5a2"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__